import { ReactNode } from 'react'

import { Text } from '../../../../components/Text'
import { TableAlignmentProps } from '../../types/alignment'
import { getCellTitle } from '../../utils/getCellTitle'
import * as Styled from './styles'

interface TableFooterItemProps extends Partial<TableAlignmentProps> {
  children: ReactNode
  truncate?: boolean
}

export const TableFooterItem = ({ alignment = 'left', children, truncate, ...restProps }: TableFooterItemProps) => {
  const title = truncate ? getCellTitle(children) : undefined

  return (
    <Styled.TableFooterItemWrapper {...restProps} alignment={alignment}>
      <Text title={title} truncate={truncate} weight="bold">
        {children}
      </Text>
    </Styled.TableFooterItemWrapper>
  )
}
